var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.38128e-07 19.4143C1.21287e-06 18.862 0.447715 18.4143 0.999999 18.4143L39 18.4143C39.5523 18.4143 40 18.862 40 19.4143L40 21.4143C40 21.9666 39.5523 22.4143 39 22.4143L1 22.4143C0.447715 22.4143 9.5981e-08 21.9666 1.10751e-06 21.4143L1.38128e-07 19.4143Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4142 40C18.862 40 18.4142 39.5523 18.4142 39L18.4142 1C18.4142 0.447715 18.862 7.90569e-08 19.4142 1.84424e-07L21.4142 2.68718e-07C21.9665 3.31938e-07 22.4142 0.447714 22.4142 0.999999L22.4142 39C22.4142 39.5523 21.9665 40 21.4142 40L19.4142 40Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon_Plus.5488b01d46d197755135fa5a7858f1de.svg";
export { ForwardRef as ReactComponent };